import React from 'react';
import Price from './Price';
import PriceDiscount from './PriceDiscount';
import Base from './Base';
import BaseDiscount from './BaseDiscount';
import TotalDiscount from './TotalDiscount';
import Total from './Total';
import { classNames } from '@payfit/growth-platform-brand-system-v2/utils/style';
import BreakdownTooltip from './BreakdownTooltips/BreakdownTooltip';
import BreakdownDiscountTooltip from './BreakdownTooltips/BreakdownDiscountTooltip';

const PriceBox = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className={classNames('PriceBox', 'flex flex-col gap-[24px]')}>
      {children}
    </div>
  );
};

PriceBox.Price = Price;
PriceBox.PriceDiscount = PriceDiscount;
PriceBox.Base = Base;
PriceBox.BaseDiscount = BaseDiscount;
PriceBox.Total = Total;
PriceBox.TotalDiscount = TotalDiscount;
PriceBox.BreakdownTooltip = BreakdownTooltip;
PriceBox.BreakdownDiscountTooltip = BreakdownDiscountTooltip;

export default PriceBox;
